import React from 'react';
import {Modal, ModalProps} from 'antd';
import {isMobile} from 'react-device-detect';
import './BaseModal.scss';

export interface BaseModalProps extends Omit<ModalProps, 'onOk' | 'onCancel'> {
  visible: boolean;
  onClose: () => void;
  title: React.ReactNode;
  children: React.ReactNode;
  width?: string | number;
  loading?: boolean;
  className?: string;
}

// TODO there are 2 base modal and a few code duplications - move it here
export const BaseModal: React.FC<BaseModalProps> = ({
  width = 1000,
  visible,
  loading = false,
  onClose,
  maskClosable = false,
  title,
  footer = null,
  className = '',
  children,
  ...restProps
}) => {
  return (
    <Modal
      {...restProps}
      width={isMobile ? '100%' : width}
      open={visible || loading}
      onCancel={onClose}
      maskClosable={maskClosable}
      title={title}
      footer={footer}
      className={`baseModal ${className}`}
    >
      {children}
    </Modal>
  );
};
